import { fetchApi } from "./api";

export type NavItemInput = {
  label: string;
  parent_id?: string | null;
  template_slug?: string | null;
  external_url?: string | null;
  display_order?: number;
  is_active?: boolean;
  open_in_new_tab?: boolean;
};

// Public: list navigation items.
export const listNavItems = () =>
  fetchApi<any[]>("content", "listNavItems", {}, { auth: false });

export const createNavItem = (opts: { data: NavItemInput }) =>
  fetchApi<any>("content", "createNavItem", opts.data);

export const updateNavItem = (opts: { data: NavItemInput & { id: string } }) =>
  fetchApi<any>("content", "updateNavItem", opts.data);

export const deleteNavItem = (opts: { data: { id: string } }) =>
  fetchApi<{ ok: true }>("content", "deleteNavItem", opts.data);

export const reorderNavItems = (opts: {
  data: { items: Array<{ id: string; display_order: number }> };
}) => fetchApi<{ ok: true }>("content", "reorderNavItems", opts.data);
